import React, { useState, useContext } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from '~components/forms/checkbox';
import { UserContext } from '~contexts/user';

import UnsubscribePopup from './unsubscribe-popup/unsubscribe-popup';

import './style.scss';

const Unsubscribe = () => {
  const intl = useIntl();

  const { user, updateWorkerParam, updateCustomerParam } = useContext(UserContext);
  const { personId, accountType, subscriptions } = user;

  const [userAlert, setUserAlert] = useState(subscriptions.userAlert);
  const [personalMessage, setPersonalMessage] = useState(subscriptions.personalMessage);
  const [isUnsubscribePopupOpened, setUnsubscribePopupOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = async (key, feKey, value) => {
    setIsSaving(true);
    try {

        const newUser = { ...user, subscriptions: { ...subscriptions, [feKey]: value}  };
        if (accountType === 'client') {
          await updateCustomerParam(personId, { [key]: value } , newUser);
        } else {
          await updateWorkerParam(personId, { [key]: value }, newUser);
        }
    
    } catch (err) {
      console.log('Error while editing subscriptions', err);
    } finally {
      setIsSaving(false);
      if(feKey === 'personalMessage' && value === false) {
        setUnsubscribePopupOpen(true);
      }
    }
  }
  return (
    <div className="c-box">
      <div className="c-box__content">
        <div className="c-editable">
          <div className="c-editable__content ">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({
                id: 'containers.account.unsubscribe.headline',
                defaultMessage: 'Notifications settings',
              })}
            </h3>
            <div className="c-account-unsubscribe">
              <Checkbox
                checked={userAlert}
                onChange={(value) => {handleChange('user_alert', 'userAlert', value); setUserAlert(value)}}
                className="c-checkbox--with-children"
                disabled={isSaving}
              >
                <div className="c-checkbox__children">
                  <div className="c-checkbox__title">
                    {intl.formatMessage({
                      id: 'containers.account.unsubscribe.new-users-alert.title',
                    })}
                  </div>
                  <div className="c-checkbox__content">
                    {intl.formatMessage({
                      id: 'containers.account.unsubscribe.new-users-alert.content',
                    })}
                  </div>
                </div>
              </Checkbox>
              <Checkbox
                checked={personalMessage}
                onChange={(value) => {handleChange('personal_message', 'personalMessage', value); setPersonalMessage(prev => !prev)}}
                className="c-checkbox--with-children"
                disabled={isSaving}
              >
                <div className="c-checkbox__children">
                  <div className="c-checkbox__title">
                    {intl.formatMessage({
                      id: 'containers.account.unsubscribe.personal-messages.title',
                    })}
                  </div>
                  <div className="c-checkbox__content">
                    {intl.formatMessage({
                      id: 'containers.account.unsubscribe.personal-messages.content',
                    })}
                  </div>
                </div>
              </Checkbox>
            </div>
          </div>
        </div>
      </div>
      <UnsubscribePopup isOpened={isUnsubscribePopupOpened} onToggle={setUnsubscribePopupOpen} />
    </div>
  );
};

export default Unsubscribe;
